module.exports = __webpack_public_path__ + "media/reskin-images/icon--play-v2-954e9989.svg";